import { EUpdateModalTitle } from 'lib/storage';
import { connect } from 'react-redux';
import { IStoreState } from 'store';
import {
  setDeleteUpdateModalIsOpen,
  setAddNewUpdateModalIsOpen,
  removeUpdateAndId,
} from 'store/add-new-update/actions';
import { IDeleteUpdateState } from 'store/add-new-update/types';
import DeleteUpdateModal from './delete-update-modal';

export interface IDeleteUpdateModalDispatchProps {
  setAddNewUpdateModalIsOpen: (isModalOpen: boolean, title: EUpdateModalTitle) => void;
  setDeleteUpdateModalIsOpen: (isDeleteUpdateModalOpen: boolean) => void;
  removeUpdateAndId: () => void;
}

export type TDeleteUpdateModalProps = IDeleteUpdateModalDispatchProps & IDeleteUpdateState;

const mapStateToProps = (state: IStoreState): IDeleteUpdateState => ({
  isDeleteUpdateModalOpen: state.addNewUpdate.isDeleteUpdateModalOpen,
  isModalOpen: state.addNewUpdate.isModalOpen,
  modalTitle: state.addNewUpdate.modalTitle,
});

const mapDispatchToProps = { setDeleteUpdateModalIsOpen, setAddNewUpdateModalIsOpen, removeUpdateAndId };

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUpdateModal);
